class RoomleIframe {
  public element: HTMLElement | null;
  public iframe: HTMLElement | null | undefined;
  public buttonOpen: HTMLElement | null | undefined;
  public buttonClose: HTMLElement | null | undefined;
  public scrollPos: number;
  public observer: IntersectionObserver;

  bindings() {
    if (this.element) {
      if (this.element.classList.contains('o-roomle-iframe--is-first')) {
        document.body.classList.add('is-header-small');
        document.body.classList.add('roomle-iframe--is-first');
        document.querySelector('.l-header')?.classList.add('l-header--small');

        this.observer = new IntersectionObserver((elements) => {
          if (elements[0].isIntersecting && window.innerWidth < 1024) {
            const position = this.element?.getBoundingClientRect().top;
            window.scrollTo({
              top: position ? position + window.scrollY - 50 : window.scrollY,
              left: 0,
              behavior: 'smooth',
            });
          }
        }, {
          threshold: 0,
        });

        this.observer.observe(this.element);
      }
    }

    if (this.buttonOpen) {
      this.buttonOpen.addEventListener('click', () => {
        this.element?.classList.add('active');

        this.scrollPos = window.scrollY;

        window.scrollTo({
          top: this.iframe?.getBoundingClientRect().top ? this.iframe?.getBoundingClientRect().top + window.scrollY : window.scrollY,
          left: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          document.body.style.width = '100%';
          document.body.style.top = `-${this.iframe?.getBoundingClientRect().top ? this.iframe?.getBoundingClientRect().top + window.scrollY : window.scrollY}px`;
          document.body.style.overflowY = 'scroll';
          document.body.style.position = 'fixed';
        }, 500);
      });
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', () => {
        this.element?.classList.remove('active');

        document.body.removeAttribute('style');

        window.scrollTo({
          top: this.scrollPos,
          left: 0,
          behavior: 'smooth',
        });
      });
    }
  }

  cache() {
    this.element = document.querySelector('.o-roomle-iframe');
    this.iframe = this.element?.querySelector('iframe');
    this.buttonOpen = this.element?.querySelector('.js-button-open');
    this.buttonClose = this.element?.querySelector('.js-button-exit');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default RoomleIframe;
